import { useAuth } from './AuthContext';
import { useWeb3Accounts } from './Web3Accounts';

export const useLoggedIn = () => {
  const { hasAccounts } = useWeb3Accounts();
  const { hasToken } = useAuth();
  const loggedIn = hasToken && hasAccounts;
  return { loggedIn };
};
